const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentNewsFeed extends HTMLDivElement {

    constructor() {
        super();
    }

    async connectedCallback() {
        await childrenLoaded(this);
        this.initialize();
    }

    async initialize() {
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        const itemsContainerElement = this.querySelector('.component-news-feed__items');
        const itemTemplateElement = this.querySelector('.component-news-feed__item-template');
        const noResultsElement = this.querySelector('.component-news-feed__no-results'); // Target the no-results container
        
        // Drupal Safety Guard: Exit cleanly if Layout Paragraphs loads before template nodes render
        if (!itemsContainerElement || !itemTemplateElement) {
            this.initialized = false;
            return;
        }
        
        const parser = new RSSParser({
            customFields: {
                item: [
                    ['media:content', 'image'],
                ]
            }
        });
        const feedURL = `/esd_request_proxy?esd-proxy-uri=${encodeURIComponent(this.getAttribute('data-feed-url'))}`;
        const feed = await parser.parseURL(feedURL);

        // --- NO RESULTS CHECK ---
        // If the feed is completely empty or the items array doesn't exist
        if (!feed || !feed.items || feed.items.length === 0) {
            if (noResultsElement) {
                noResultsElement.style.display = 'block'; // Unhide the Twig fallback message
            }
            return; // Exit out of initialize() early since there's nothing to loop over
        } else {
            if (noResultsElement) {
                noResultsElement.style.display = 'none'; // Ensure it's hidden if we do have results
            }
        }

        // Set display template & set which fields should be populated
        const template = this.getAttribute('data-display-template');
        let arr = [];

        switch(template) {
            case "card":
            case "list_with_image":
                arr = ["image", "title", "description", "date"]; // Fixed "tite" to "title"
                break;
            case "card_without_image":
            case "list_without_image":
            case "media_clips":
                arr = ["title", "description", "date"]; // Fixed "tite" to "title"
                break;
            case "bullet_list":
                arr = ["title", "date"];
                break;
            default:
                arr = [];
        }

        // Check if max items to display is greater than # of items in XML feed
        // Set result to display count
        const maxItemsAttr = this.getAttribute('data-max-items');
        
        // Convert to an integer, or fallback to the total feed length if blank
        const maxItems = maxItemsAttr ? parseInt(maxItemsAttr, 10) : feed.items.length;

        // Run the loop, ensuring it stops if the feed runs out of items early
        for (let i = 0; i < maxItems && i < feed.items.length; i++) {
            if (!feed.items[i]) {
                break;
            }
            let itemElement;
            if (itemTemplateElement.content) {
                // If it's a true <template> tag, clone its inner content fragment
                itemElement = itemTemplateElement.content.cloneNode(true);
            } else {
                // Fallback: If it's a regular <div> container, clone the element itself
                itemElement = itemTemplateElement.cloneNode(true);
                // Optional: Remove the template class so it doesn't conflict with layout styles
                itemElement.classList.remove('component-news-feed__item-template');
            }

            const itemLinkElement = itemElement.querySelector('.component-news-feed__item-link');
            if (itemLinkElement && feed.items[i]['link']) {
                itemLinkElement.setAttribute('href', feed.items[i]['link']);
            }
            
            if (arr.includes("image")) {
                const itemImageElement = itemElement.querySelector('.component-news-feed__item-image');
                if (itemImageElement) {
                    // possibly set fallback image if no image is found in the feed item.
                    let imageUrl = null;
                    if (feed.mediaContent && feed.mediaContent['$'] && feed.mediaContent['$'].url) {
                        imageUrl = item.mediaContent['$'].url;
                    }
                    if (feed.items[i]?.['image']?.['$']?.['url']) {
                        imageUrl = feed.items[i]['image']['$']['url'];
                    }
                    itemImageElement.setAttribute('src', imageUrl);
                }
            }
            
            if (arr.includes("title")) {
                const itemTitleElement = itemElement.querySelector('.component-news-feed__item-title');
                if (itemTitleElement) {
                    const cleanedHTML = decodeHTMLEntities(feed.items[i].title);
                    itemTitleElement.innerHTML = cleanedHTML;
                }
            }
            
            if (arr.includes("description")) {
                const itemDescriptionElement = itemElement.querySelector('.component-news-feed__item-description');
                if (itemDescriptionElement) {
                    let rawText = '';
                    if (feed.items[i].contentSnippet && feed.items[i].contentSnippet !== 'undefined') {
                        rawText = feed.items[i].contentSnippet;
                    } else if (feed.items[i].description) {
                        rawText = feed.items[i].description;
                    }

                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = rawText;
                    
                    const mutedSpan = tempDiv.querySelector('span.text-muted');
                    const pubdateSpan = tempDiv.querySelector('span.t-pubdate');
                    if (mutedSpan) {
                        mutedSpan.remove();
                    }
                    if (pubdateSpan) {
                        pubdateSpan.remove();
                    }
                    
                    const cleanedHTML = decodeHTMLEntities(tempDiv.innerHTML);
                    const cleanedText = cleanedHTML.replace(/^[A-Za-z]{3}\s\d{1,2},\s\d{4}\s*/, "");
                    itemDescriptionElement.textContent = cleanedText;
                }
            }
            
            if (arr.includes("date")) {
                const itemDateElement = itemElement.querySelector('.component-news-feed__item-date');
                if (itemDateElement && feed.items[i]['isoDate']) {
                    let itemDate = new Date(feed.items[i]['isoDate']);
                    itemDate = itemDate.toLocaleDateString('en-US', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                    });
                    itemDateElement.textContent = itemDate;
                }
            }
            
            itemsContainerElement.appendChild(itemElement);
        }
    }
}
function decodeHTMLEntities(text) {
  const textArea = document.createElement("textarea");
  textArea.innerHTML = text;
  return textArea.value;
}

customElements.define('component-news-feed', ComponentNewsFeed, {extends: 'div'});